import { createMongoAbility } from '@casl/ability';
import { abilitiesPlugin } from '@casl/vue';
import { initialAbility } from './config';


// Recupera las habilidades del localStorage
const habilidades = localStorage.getItem('habilidades') ? JSON.parse(localStorage.getItem('habilidades')) : null;

// Combina las habilidades existentes con las habilidades iniciales
const existingAbility = habilidades ? [...habilidades, ...initialAbility] : initialAbility;

// Crea la habilidad usando createMongoAbility
const ability = createMongoAbility(existingAbility);

// Exporta la habilidad
export default ability;

// Configura el plugin de CASL para Vue
const app = createApp({});
app.use(abilitiesPlugin, ability);